module.exports = __webpack_public_path__ + "static/media/cardiconhover.9d02226c.svg";